import { render, staticRenderFns } from "./StorageFormGroup.vue?vue&type=template&id=696bbd85&"
import script from "./StorageFormGroup.vue?vue&type=script&lang=ts&"
export * from "./StorageFormGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports